/* tslint:disable */
/* eslint-disable */
/**
 * LWM portal
 * Lamb-Weston Meijer Portal API documentation
 *
 * The version of the OpenAPI document: 3.3.11
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { BasePaginationResponse } from '../model';
// @ts-ignore
import { CreateAttachmentRequest } from '../model';
// @ts-ignore
import { InlineResponse201 } from '../model';
// @ts-ignore
import { SalesQuote } from '../model';
// @ts-ignore
import { Success } from '../model';
/**
 * ClaimApi - axios parameter creator
 * @export
 */
export const ClaimApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Endpoint for generating pre-signed S3 url for uploading claim attachment.
         * @summary Endpoint for generating pre-signed S3 url for uploading claim attachment.
         * @param {CreateAttachmentRequest} createAttachmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        claimsCreateAttachmentPost: async (createAttachmentRequest: CreateAttachmentRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'createAttachmentRequest' is not null or undefined
            assertParamExists('claimsCreateAttachmentPost', 'createAttachmentRequest', createAttachmentRequest)
            const localVarPath = `/claims/create-attachment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication development-5i2kpscjb65ib9kesn4v8t0121 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "development-5i2kpscjb65ib9kesn4v8t0121", [], configuration)

            // authentication production-65i3ire9nqi9c80lduc24r7rjq required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "production-65i3ire9nqi9c80lduc24r7rjq", [], configuration)

            // authentication staging-6ggnttq03clhsfllacr07d2uit required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "staging-6ggnttq03clhsfllacr07d2uit", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAttachmentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Claims will be returned for the logged in (Cognito) user
         * @summary Get overview of all claims
         * @param {number} [perPage] Number of items per page (default&#x3D;25)
         * @param {number} [page] Requested page (default&#x3D;1)
         * @param {string} [filter] Filter claim fields, parameter may be repeated to add multiple filters.
         * @param {string} [search] Search claim fields.
         * @param {string} [sort] Fieldname to sort results on.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        claimsGet: async (perPage?: number, page?: number, filter?: string, search?: string, sort?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/claims`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication development-5i2kpscjb65ib9kesn4v8t0121 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "development-5i2kpscjb65ib9kesn4v8t0121", [], configuration)

            // authentication production-65i3ire9nqi9c80lduc24r7rjq required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "production-65i3ire9nqi9c80lduc24r7rjq", [], configuration)

            // authentication staging-6ggnttq03clhsfllacr07d2uit required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "staging-6ggnttq03clhsfllacr07d2uit", [], configuration)

            if (perPage !== undefined) {
                localVarQueryParameter['per_page'] = perPage;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Endpoint for submitting a claim.
         * @summary Endpoint for submitting a claim.
         * @param {SalesQuote} salesQuote 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        claimsPost: async (salesQuote: SalesQuote, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'salesQuote' is not null or undefined
            assertParamExists('claimsPost', 'salesQuote', salesQuote)
            const localVarPath = `/claims`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication development-5i2kpscjb65ib9kesn4v8t0121 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "development-5i2kpscjb65ib9kesn4v8t0121", [], configuration)

            // authentication production-65i3ire9nqi9c80lduc24r7rjq required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "production-65i3ire9nqi9c80lduc24r7rjq", [], configuration)

            // authentication staging-6ggnttq03clhsfllacr07d2uit required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "staging-6ggnttq03clhsfllacr07d2uit", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(salesQuote, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClaimApi - functional programming interface
 * @export
 */
export const ClaimApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ClaimApiAxiosParamCreator(configuration)
    return {
        /**
         * Endpoint for generating pre-signed S3 url for uploading claim attachment.
         * @summary Endpoint for generating pre-signed S3 url for uploading claim attachment.
         * @param {CreateAttachmentRequest} createAttachmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async claimsCreateAttachmentPost(createAttachmentRequest: CreateAttachmentRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse201>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.claimsCreateAttachmentPost(createAttachmentRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Claims will be returned for the logged in (Cognito) user
         * @summary Get overview of all claims
         * @param {number} [perPage] Number of items per page (default&#x3D;25)
         * @param {number} [page] Requested page (default&#x3D;1)
         * @param {string} [filter] Filter claim fields, parameter may be repeated to add multiple filters.
         * @param {string} [search] Search claim fields.
         * @param {string} [sort] Fieldname to sort results on.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async claimsGet(perPage?: number, page?: number, filter?: string, search?: string, sort?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BasePaginationResponse & object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.claimsGet(perPage, page, filter, search, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Endpoint for submitting a claim.
         * @summary Endpoint for submitting a claim.
         * @param {SalesQuote} salesQuote 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async claimsPost(salesQuote: SalesQuote, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Success>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.claimsPost(salesQuote, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ClaimApi - factory interface
 * @export
 */
export const ClaimApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ClaimApiFp(configuration)
    return {
        /**
         * Endpoint for generating pre-signed S3 url for uploading claim attachment.
         * @summary Endpoint for generating pre-signed S3 url for uploading claim attachment.
         * @param {CreateAttachmentRequest} createAttachmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        claimsCreateAttachmentPost(createAttachmentRequest: CreateAttachmentRequest, options?: any): AxiosPromise<InlineResponse201> {
            return localVarFp.claimsCreateAttachmentPost(createAttachmentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Claims will be returned for the logged in (Cognito) user
         * @summary Get overview of all claims
         * @param {number} [perPage] Number of items per page (default&#x3D;25)
         * @param {number} [page] Requested page (default&#x3D;1)
         * @param {string} [filter] Filter claim fields, parameter may be repeated to add multiple filters.
         * @param {string} [search] Search claim fields.
         * @param {string} [sort] Fieldname to sort results on.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        claimsGet(perPage?: number, page?: number, filter?: string, search?: string, sort?: string, options?: any): AxiosPromise<BasePaginationResponse & object> {
            return localVarFp.claimsGet(perPage, page, filter, search, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * Endpoint for submitting a claim.
         * @summary Endpoint for submitting a claim.
         * @param {SalesQuote} salesQuote 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        claimsPost(salesQuote: SalesQuote, options?: any): AxiosPromise<Success> {
            return localVarFp.claimsPost(salesQuote, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ClaimApi - object-oriented interface
 * @export
 * @class ClaimApi
 * @extends {BaseAPI}
 */
export class ClaimApi extends BaseAPI {
    /**
     * Endpoint for generating pre-signed S3 url for uploading claim attachment.
     * @summary Endpoint for generating pre-signed S3 url for uploading claim attachment.
     * @param {CreateAttachmentRequest} createAttachmentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimApi
     */
    public claimsCreateAttachmentPost(createAttachmentRequest: CreateAttachmentRequest, options?: any) {
        return ClaimApiFp(this.configuration).claimsCreateAttachmentPost(createAttachmentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Claims will be returned for the logged in (Cognito) user
     * @summary Get overview of all claims
     * @param {number} [perPage] Number of items per page (default&#x3D;25)
     * @param {number} [page] Requested page (default&#x3D;1)
     * @param {string} [filter] Filter claim fields, parameter may be repeated to add multiple filters.
     * @param {string} [search] Search claim fields.
     * @param {string} [sort] Fieldname to sort results on.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimApi
     */
    public claimsGet(perPage?: number, page?: number, filter?: string, search?: string, sort?: string, options?: any) {
        return ClaimApiFp(this.configuration).claimsGet(perPage, page, filter, search, sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Endpoint for submitting a claim.
     * @summary Endpoint for submitting a claim.
     * @param {SalesQuote} salesQuote 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimApi
     */
    public claimsPost(salesQuote: SalesQuote, options?: any) {
        return ClaimApiFp(this.configuration).claimsPost(salesQuote, options).then((request) => request(this.axios, this.basePath));
    }
}
